import React, { Component } from "react";
import { Link } from "gatsby";



class HomeBanner extends  Component{
    
 
    render()
    {
        

        return (
            <section class="banner-sec">
            <div class="swiper-container banner-swiper">
                <div class="swiper-wrapper">
                    
                    <div class="swiper-slide">
                        <div class="banner-inner"> 
                            <div class="image-holder">
                                <div class="dasktop-version">
                                    <img data-src="https://res.cloudinary.com/image/upload/v1604909673/NewHome/banner-img2_qbs0r8.png" alt="" className="lazyload"/>
                                </div>
                                <div class="mobile-version">
                                    <img data-src="https://res.cloudinary.com/image/upload/v1604992004/NewHome/banner-mobile2-min_sldvba.png" class="img-fluid" alt="" className="lazyload"/>
                                    <div class="text-inner">
                                        <h1>Reverse Diabetes in 90 days*</h1>
                                        <h3>Stop Medicines. Normalise Sugar. 100% Healthy & Happy.</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="text-box">
                                <h1>Reverse Diabetes in 90 days*</h1>
                                <h3>Stop Medicines. Normalise Sugar. 100% Healthy & Happy.</h3>
                                <Link to="/free-consultation"><a href="#">BOOK A FREE CONSULTATION</a></Link>
                                {/* <p>Twin treatment offered by India’s leading doctors</p> */}
                            </div>
                        </div> 
                    </div> 
                    <div class="swiper-slide">
                        <div class="banner-inner">
                            <div class="image-holder">
                                <div class="dasktop-version">
                                    <img data-src="https://res.cloudinary.com/image/upload/v1604909638/NewHome/banner-img1_c4qbe8.png" alt="" className="lazyload"/>
                                </div>
                                <div class="mobile-version">
                                    <img data-src="https://res.cloudinary.com/image/upload/v1604909645/NewHome/banner-mobile1_rjkemz.jpg" class="img-fluid" alt="" className="lazyload"/>
                                    <div class="text-inner">
                                        <h1>Know how leading doctors are reversing diabetes!</h1>
                                    </div>
                                </div>
                            </div>
                            <div class="text-box">
                                <h1>Know how leading doctors are reversing diabetes!</h1>
                                <Link to="/webinar"><a href="#"> REGISTER FOR A FREE WEBINAR</a></Link>
                            </div> 
                        </div>
                    </div>

                   
                    <div class="swiper-slide">
                        <div class="banner-inner"> 
                            <div class="image-holder">
                                <div class="dasktop-version">
                                    <img data-src="https://res.cloudinary.com/image/upload/v1604909673/NewHome/banner-img2_qbs0r8.png" alt="" className="lazyload"/>
                                </div>
                                <div class="mobile-version">
                                    <img data-src="https://res.cloudinary.com/image/upload/v1604992004/NewHome/banner-mobile2-min_sldvba.png" class="img-fluid" alt="" className="lazyload"/>
                                    <div class="text-inner">
                                        <h1>Reverse Diabetes in 90 days*</h1>
                                        <h3>Stop Medicines. Normalise Sugar. 100% Healthy & Happy.</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="text-box">
                                <h1>Reverse Diabetes in 90 days*</h1>
                                <h3>Stop Medicines. Normalise Sugar. 100% Healthy & Happy.</h3>
                                <Link to="/free-consultation"><a href="#">BOOK A FREE CONSULTATION</a></Link>
                                {/* <p>Twin treatment offered by India’s leading doctors</p> */}
                            </div>
                        </div> 
                    </div> 
                    <div class="swiper-slide">
                        <div class="banner-inner">
                            <div class="image-holder">
                                <div class="dasktop-version">
                                    <img data-src="https://res.cloudinary.com/image/upload/v1604909638/NewHome/banner-img1_c4qbe8.png" alt="" className="lazyload"/>
                                </div>
                                <div class="mobile-version">
                                    <img data-src="https://res.cloudinary.com/image/upload/v1604909645/NewHome/banner-mobile1_rjkemz.jpg" class="img-fluid" alt="" className="lazyload"/>
                                    <div class="text-inner">
                                        <h1>Know how leading doctors are reversing diabetes!</h1>
                                    </div>
                                </div>
                            </div>
                            <div class="text-box">
                                <h1>Know how leading doctors are reversing diabetes!</h1>
                                <Link to="/webinar"><a href="#"> REGISTER FOR A FREE WEBINAR</a></Link>
                            </div> 
                        </div>
                    </div>


                   
                    <div class="swiper-slide">
                        <div class="banner-inner"> 
                            <div class="image-holder">
                                <div class="dasktop-version">
                                    <img data-src="https://res.cloudinary.com/image/upload/v1604909673/NewHome/banner-img2_qbs0r8.png" alt="" className="lazyload"/>
                                </div>
                                <div class="mobile-version">
                                    <img data-src="https://res.cloudinary.com/image/upload/v1604992004/NewHome/banner-mobile2-min_sldvba.png" class="img-fluid" alt="" className="lazyload"/>
                                    <div class="text-inner">
                                        <h1>Reverse Diabetes in 90 days*</h1>
                                        <h3>Stop Medicines. Normalise Sugar. 100% Healthy & Happy.</h3>
                                    </div>
                                </div>
                            </div>
                            <div class="text-box">
                                <h1>Reverse Diabetes in 90 days*</h1>
                                <h3>Stop Medicines. Normalise Sugar. 100% Healthy & Happy.</h3>
                                <Link to="/free-consultation"><a href="#">BOOK A FREE CONSULTATION</a></Link>
                                {/* <p>Twin treatment offered by India’s leading doctors</p> */}
                            </div>
                        </div> 
                    </div> 
                    <div class="swiper-slide">
                        <div class="banner-inner">
                            <div class="image-holder">
                                <div class="dasktop-version">
                                    <img data-src="https://res.cloudinary.com/image/upload/v1604909638/NewHome/banner-img1_c4qbe8.png" alt="" className="lazyload"/>
                                </div>
                                <div class="mobile-version">
                                    <img data-src="https://res.cloudinary.com/image/upload/v1604909645/NewHome/banner-mobile1_rjkemz.jpg" class="img-fluid" alt="" className="lazyload"/>
                                    <div class="text-inner">
                                        <h1>Know how leading doctors are reversing diabetes!</h1>
                                    </div>
                                </div>
                            </div>
                            <div class="text-box">
                                <h1>Know how leading doctors are reversing diabetes!</h1>
                                <Link to="/webinar"><a href="#"> REGISTER FOR A FREE WEBINAR</a></Link>
                            </div> 
                        </div>
                    </div>


                </div>
            </div>
        </section>
        )
    }

}
export default HomeBanner